import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ArrowForwardIos } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { userPackerGroup, userPickerGroup } from 'commons/types/userGroup';
import { CheckUserRoles } from 'commons/utils/checkUserRoles';
import {
  DELIVERY_NOTE_ROUTES,
  PACK_TASK_ROUTES,
  PICK_TASK_ROUTES,
} from 'routes/constants';

import UserInfoHeader from './components/UserInfoHeader.component';
import S from './HomePage.styles';

const HomePageOutbound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <UserInfoHeader />

      {/* Menu Options */}
      {/* Picking */}
      {CheckUserRoles(userPickerGroup) ? (
        <S.MenuOption
          onClick={(): void => navigate(PICK_TASK_ROUTES.ASSIGN)}
          data-testid="BtnMenuPicking"
        >
          <Grid container>
            <Grid item xs={2}>
              <S.MenuIcon src="/assets/picking-icon.svg" alt="picking-icon" />
            </Grid>
            <Grid item xs={8}>
              <S.MenuText>Picking</S.MenuText>
            </Grid>
            <Grid item xs={2}>
              <ArrowForwardIos
                fontSize="small"
                style={{ marginTop: 14, textAlign: 'right' }}
              />
            </Grid>
          </Grid>
        </S.MenuOption>
      ) : null}

      {/* Checking and packing */}
      {CheckUserRoles(userPackerGroup) ? (
        <S.MenuOption
          onClick={() => navigate(PACK_TASK_ROUTES.CHECK_BASKET)}
          data-testid="BtnMenuCheckingPacking"
        >
          <Grid container>
            <Grid item xs={2}>
              <S.MenuIcon src="/assets/checking-icon.svg" alt="checking-icon" />
            </Grid>
            <Grid item xs={8}>
              <S.MenuText>Checking & Packing</S.MenuText>
            </Grid>
            <Grid item xs={2}>
              <ArrowForwardIos
                fontSize="small"
                style={{ marginTop: 14, textAlign: 'right' }}
              />
            </Grid>
          </Grid>
        </S.MenuOption>
      ) : null}

      {/* Delivery Note */}
      {CheckUserRoles(userPackerGroup) ? (
        <S.MenuOption
          onClick={() => navigate(DELIVERY_NOTE_ROUTES.LIST)}
          data-testid="BtnMenuDeliveryNote"
        >
          <Grid container>
            <Grid item xs={2}>
              <S.MenuIcon
                src="/assets/delivery-note-icon.svg"
                alt="delivery-note-icon"
              />
            </Grid>
            <Grid item xs={8}>
              <S.MenuText>Delivery Note</S.MenuText>
            </Grid>
            <Grid item xs={2}>
              <ArrowForwardIos
                fontSize="small"
                style={{ marginTop: 14, textAlign: 'right' }}
              />
            </Grid>
          </Grid>
        </S.MenuOption>
      ) : null}
    </div>
  );
};

export default HomePageOutbound;
